import { Alert, StatusState } from '@bytel/trilogy-react';

interface PlanRenewDelayAlertProps {
    renewDelay?: number;
}

export function PlanRenewDelayAlert({ renewDelay = 12 }: Readonly<PlanRenewDelayAlertProps>) {
    return (
        <Alert
            status={StatusState.INFO}
            title="Vous changez d'offre&nbsp;?"
            description={`En changeant d'offre, vous ne pourrez plus remplacer votre téléphone à partir du ${renewDelay}ème mois.`}
            display
        />
    );
}
